import { FC, useRef, useState } from 'react';
import Button from '@eg/elements/Button';
import { Tracker } from 'src/tracking/tracker';
import { TrackingElementSigningPage } from 'src/tracking/tracking.types';

const WINDOW_NAME = 'posag-signing-window';
const tracker = Tracker.getInstance();

interface POSAGSignatureWindowProps {
  url: string;
  onError: () => void;
}
export const POSAGSignatureWindow: FC<POSAGSignatureWindowProps> = ({ url, onError }) => {
  const [windowOpened, setWindowOpened] = useState(false);
  const signingWindowRef = useRef<Window | null>();

  const openOrFocus = () => {
    tracker.trackClickEvent({ clickedElement: TrackingElementSigningPage.BUTTON_SIGN_SECURELY_NOW });
    if (signingWindowRef.current && !signingWindowRef.current.closed) {
      try {
        signingWindowRef.current.location.assign(url);
      } catch {
        signingWindowRef.current = window.open(url, WINDOW_NAME);
      }
      signingWindowRef.current?.focus?.();
      return;
    }
    signingWindowRef.current = window.open(url, WINDOW_NAME);
    if (!signingWindowRef.current) {
      console.warn('Popup was blocked. Please allow popups for this site.');
      onError();
      return;
    }
    signingWindowRef.current.focus?.();
    setWindowOpened(true);
  };


  return (
    <div className="window-opener">
      <p>
        <b>So funktioniert's:</b>
        <ol>
          <li>Unterschreiben Sie im <b>neuen Browsertab</b>: Sie werden zur Unterschrift weitergeleitet.</li>
          <li>Kehren Sie nach dem Unterschreiben hierher zurück: Lassen Sie <b>diesen Tab unbedingt geöffnet</b>.</li>
          <li>Online <b>beantragen</b>: Damit senden Sie Ihren unterschriebenen Antrag ab.</li>
        </ol>
      </p>
      {windowOpened && (
        // Some text after opening signing window, like instructions if he accidentally closes signing window or finished a process but due to communication delay still didnt jump to next state
        <>
          <p>
            <b>Hier geht es weiter, sobald Ihre
            Unterschriften ins Antragsdokument
              übertragen wurden.</b>
          </p>
          <p>
            Sie haben noch nicht unterschrieben und
            sehen den Browsertab für die Unterschrift
            nicht? Hier können Sie ihn wieder öffnen.
          </p>
        </>
      )}
      <div className="window-opener-button-wrapper">
        <Button
          className="window-opener-button"
          type="button"
          variant={'primary'}
          onClick={openOrFocus}
          >Jetzt sicher unterschreiben</Button>
        </div>
    </div>
  );
};
